import React, { useState, useEffect } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useNavigate } from 'react-router-dom';
import { useContextData } from '../ContextData';
import { useIsMobile } from '../../helpers/customHooks';
import axios from 'axios';
import NewButton from '../Buttons/NewButton';


const LogoutModal = (props) => {
    const MOBILE = useIsMobile();
    const { setAccessToken, setDeviceListMap, setDeviceListCompact } = useContextData();

    const navigate = useNavigate()
    const { t } = useTranslation();
    const [show, setShow] = useState(props.show)
    const [errorText, setErrorText] = useState("")

    useEffect(() => {
        setShow(props.show)

    },[props.show])

    
    const handleClose = () => {
        props.onClose()
      //  setShow(false)
    }

    let cancelTokenSource = axios.CancelToken.source();

    // Function to cancel all ongoing requests
    const cancelOngoingRequests = () => {
        cancelTokenSource.cancel('Logout initiated: Cancelling all ongoing requests.');
        // Create a new CancelToken source for future requests
        cancelTokenSource = axios.CancelToken.source();
    };


    const logout = () => {
        cancelOngoingRequests(); // Cancel ongoing requests
        localStorage.clear()
        setAccessToken(null)
        setDeviceListMap([])
        setDeviceListCompact([])
    }

    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100 grey-blue">
                    <div className="p-3">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className='d-flex align-items-center'>
                                <h3 className="">{t("settings.logout")}</h3>
                            </div>
                            <img className="cursor-pointer" src={icons.close_gray} onClick={() => props.onClose()} alt="..." /> 
                        </div>
                        <p className="grey-blue pt-3">{t("settings.logout_body")}</p>
                        <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                            <NewButton onClick={() => props.onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                            <NewButton onClick={() => logout()} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.logout")}</NewButton>
                        </div>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default LogoutModal;